<template>
    <div class="myPage99">
        <div class="myFlexBox m_width m_mar0a">
            <div class="breadCrumbBox m_flex m_aic m_jcs">
                <div class="itemBox m_flex m_aic m_jcc" v-for="(item, index) in breadCrumbList" :key="index">
                    <div class="text" :class="{ isLink: item.path }" @click="goPage(item.path)">
                        {{ item.title }}
                    </div>
                    <i class="el-icon-arrow-right icon" v-if="index != breadCrumbList.length - 1"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        breadCrumbList: {
            type: Array,
            required: false,
            default: [],
        },
    },
    data() {
        return {}
    },
    created() {},
    mounted() {},
    methods: {
        goPage(path) {
            if (path) {
                this.$router.push(path)
            }
        },
    },
}
</script>
<style lang="less" scoped>
.myPage99 {
    margin-top: 26px;
}

.myFlexBox {
    .breadCrumbBox {
        width: 100%;

        .text {
            font-size: 14px;
            line-height: 24px;
        }

        .isLink {
            cursor: pointer;
            color: #d61818;
            font-weight: bold;
        }

        .icon {
            font-size: 14px;
            line-height: 24px;
            margin: 0 4px;
        }
    }
}
</style>
<style lang="less" scoped src="./style/h5-breadcrumb.less"></style>
